<canvas
    #canvas
    (touchstart)="startDrawing($event)"
    (touchmove)="moved($event)"
    width="700"
    height="200">
</canvas>
<div class="signature-actions">
    <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="savePad()">
        Save Drawn Signature
    </button>
    <button
        mat-stroked-button
        type="button"
        (click)="undoSign()">
        Undo
    </button>
    <button
        mat-stroked-button
        type="button"
        (click)="clearPad()">
        Clear Signature
    </button>
    <label class="upload-label">
        Upload Image
        <input
            type="file"
            accept="image/*"
            (change)="onFileSelected($event)" />
    </label>
</div>
<div class="signature-help">
    <span>
        Draw a signature or upload an image, then save.
        The saved signature is used on forms when your role matches
        Admin/Staff, Judge, or Prosecutor tags.
    </span>
    <div
        class="signature-error"
        *ngIf="uploadError">
        {{ uploadError }}
    </div>
    <div *ngIf="signatureImg || savedSignatureUrl">
        <img
            class="signature"
            [src]="signatureImg || savedSignatureUrl"
            alt="Saved signature preview" />
    </div>
</div>
